import { render, staticRenderFns } from "./JobSearchAssistanceList.vue?vue&type=template&id=a94e98e8&"
import script from "./JobSearchAssistanceList.vue?vue&type=script&lang=js&"
export * from "./JobSearchAssistanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports